<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 25 25" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M8.33325 3.33333V1.66667H16.6666V3.33333H8.33325ZM7.91659 0C7.22624 0 6.66659 0.559643 6.66659 1.25V1.66667H5.83325C4.45254 1.66667 3.33325 2.78595 3.33325 4.16667V20.8333C3.33325 22.214 4.45254 23.3333 5.83325 23.3333H19.1666C20.5473 23.3333 21.6666 22.214 21.6666 20.8333V4.16667C21.6666 2.78595 20.5473 1.66667 19.1666 1.66667H18.3333V1.25C18.3333 0.559643 17.7736 0 17.0833 0H7.91659ZM18.3333 3.33333V3.75C18.3333 4.44035 17.7736 5 17.0833 5H7.91659C7.22624 5 6.66659 4.44035 6.66659 3.75V3.33333H5.83325C5.37302 3.33333 4.99992 3.70643 4.99992 4.16667V20.8333C4.99992 21.2935 5.37302 21.6667 5.83325 21.6667H19.1666C19.6268 21.6667 19.9999 21.2935 19.9999 20.8333V4.16667C19.9999 3.70643 19.6268 3.33333 19.1666 3.33333H18.3333Z" />
  </svg>
</template>
<style scoped>
  svg {
    transition: all 0.3s ease-in-out;
  }
</style>
